export default "__VITE_ASSET__c29517b4__"